import React, { useEffect, useState } from "react";
import { Card, Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { fetchCategoryClassificationData } from "../redux/slice/QuickReportSlice";
import { successStatusCode } from "../utils/constants";
import { fetchIncidentDetails } from "../redux/slice/DashboardListingSlice";
import { Skeleton } from "@mui/material";
import { ResponsivePie } from "@nivo/pie";

const IncidentDetails = () => {
  const dispatch = useDispatch();
  const [categoryList, setCategoryList] = useState([]);
  const [category, setCategory] = useState("");
  const [data, setData] = useState([
    {
      id: "Moderate",
      label: "Moderate",
      value: 25,
      color: "hsla(128, 48%, 40%, 1)",
    },
    {
      id: "Major",
      label: "Major",
      value: 25,
      color: "hsla(40, 100%, 49%, 1)",
    },
    {
      id: "Severe",
      label: "Severe",
      value: 25,
      color: "hsla(0, 100%, 49%, 1)",
    },
    { id: "Minor", label: "Minor", value: 25, color: "hsla(86, 59%, 60%, 1)" },
  ]);
  const [loading, setLoading] = useState(false);
  const handleCategory = (e) => {
    const { value } = e.target;
    setCategory(value);
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await dispatch(fetchCategoryClassificationData());
        const result = res?.payload;
        if (result?.status === successStatusCode) {
          const data = result?.data?.Incidents ?? [];
          setCategoryList(data);
          setCategory(data?.[0]?.name ?? "");
        }
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (category) {
      const fetchData = async () => {
        setLoading(true);
        try {
          const res = await dispatch(fetchIncidentDetails(category));
          if (res?.payload?.status === successStatusCode) {
            const data = res?.payload?.data;
            const pieData = [
              {
                id: "Moderate",
                label: "Moderate",
                value: Math.round(data.moderate_percent),
                color: "hsla(128, 48%, 40%, 1)",
              },
              {
                id: "Major",
                label: "Major",
                value: Math.round(data.major_percent),
                color: "hsla(40, 100%, 49%, 1)",
              },
              {
                id: "Severe",
                label: "Severe",
                value: Math.round(data.severe_percent),
                color: "hsla(0, 100%, 49%, 1)",
              },
              {
                id: "Minor",
                label: "Minor",
                value: Math.round(data.minor_percent),
                color: "hsla(86, 59%, 60%, 1)",
              },
            ];
            setData(pieData?.filter((item) => item?.value > 0));
          }
        } catch (error) {
          console.error("Error fetching dashboard data:", error);
        } finally {
          setLoading(false);
        }
      };

      fetchData();
    }
  }, [dispatch, category]);

  return (
    <Card className="dashboard_cards h-100" style={{ border: "none" }}>
      <Card.Body className="">
        <Card.Title style={{ fontWeight: 500 }} className="mb-0 text_gray">
          Past 30 Days Incidents Details
        </Card.Title>
        <Form.Select
          placeholder="Select a category"
          value={category}
          onChange={handleCategory}
          className="w-auto text_gray mt-3"
        >
          <option
            value=""
            disabled
            className="option-title"
            key="Select a category"
          >
            Select a category
          </option>
          {categoryList.map((option) => (
            <option key={option.name} value={option.name} className="text_gray">
              {option.name}
            </option>
          ))}
        </Form.Select>
        {loading ? (
          <div
            className="d-flex mt-3"
            style={{ width: "334px", height: "334px", margin: "auto" }}
          >
            <Skeleton
              variant="circular"
              sx={{ width: "100%", height: "100%" }}
            />
          </div>
        ) : (
          <div className="d-flex justify-content-center">
            <div
              className="d-flex flex-column justify-content-center align-items-center"
              style={{
                maxWidth: "350px",
                width: "100%",
                height: "350px",
              }}
            >
              {data.length > 0 ? (
                <ResponsivePie
                  data={data}
                  margin={{ top: 60, right: 60, left: 60, bottom: 60 }}
                  innerRadius={0.5}
                  padAngle={5}
                  arcLinkLabelsTextColor="#A8A8BD"
                  arcLinkLabelsColor={{ from: "transparent" }}
                  arcLinkLabelsStraightLength={3}
                  arcLabelsSkipAngle={0}
                  arcLabel={(e) => `${e.value}%`}
                  colors={{ datum: "data.color" }}
                  activeInnerRadiusOffset={5}
                  activeOuterRadiusOffset={15}
                  motionConfig="gentle"
                  theme={{
                    labels: {
                      text: {
                        fontFamily: "Inter, sans-serif",
                        fontSize: 16,
                        fill: "#FFFFFF",
                      },
                    },
                  }}
                />
              ) : (
                <ResponsivePie
                  data={[
                    {
                      id: "No data",
                      label: "No Data",
                      value: 1,
                      color: "hsla(0, 0%, 85%, 1)",
                    },
                  ]}
                  margin={{ top: 40, right: 40, left: 40, bottom: 40 }}
                  innerRadius={0.7}
                  padAngle={2}
                  enableArcLabels={false}
                  enableArcLinkLabels={false}
                  tooltip={() => null}
                  colors={{ datum: "data.color" }}
                  layers={[
                    "arcs",
                    "slices",
                    ({ centerX, centerY }) => (
                      <g transform={`translate(${centerX}, ${centerY})`}>
                        <text
                          textAnchor="middle"
                          dominantBaseline="central"
                          fill="#16161d"
                          fontSize="16"
                          fontFamily="Inter, sans-serif"
                        >
                          No Data Found
                        </text>
                      </g>
                    ),
                  ]}
                />
              )}
            </div>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default IncidentDetails;
